export const checkScrollAtBottom = containerDiv => {
  // console.log(
  //   containerDiv.scrollHeight - containerDiv.scrollTop,
  //   containerDiv.clientHeight
  // );
  return (
    Math.abs(
      containerDiv.scrollHeight -
        containerDiv.scrollTop -
        containerDiv.clientHeight
    ) < 5 && containerDiv.scrollTop > 0
  );
};

// this util is to detect end of horizontal scroll
export const checkScrollAtTheEnd = (containerDiv, offset = 10) => {
  const { scrollLeft, scrollWidth, offsetWidth } = containerDiv || {};

  return Math.abs(Math.round(scrollLeft + offsetWidth) - scrollWidth) < offset;
};
